import React from "react";
import { Switch, Route, BrowserRouter as Router } from "react-router-dom";
import { createBrowserHistory } from "history";

import GuestRoute from "./guest";

import Login from "../pages/login";
import Error404 from "../pages/404";
import Rotas from "./rotas";

const history = createBrowserHistory();

const Routes = () => {
  return (
    <Router history={history}>
      <Switch>
        {Rotas()}
        <GuestRoute path="/login" exact component={Login} />
        <Route path="*" component={Error404} />
      </Switch>
    </Router>
  );
};

export default Routes;
